<div class="w-full px-3 py-4 bg-white">
  <div class="xl:flex items-center justify-between mb-4">
    <div class="flex items-center justify-start gap-1 lg:gap-2 mb-3 lg:mb-0">
      <!-- Back Button SVG (clickable) -->
    <svg class="size-6 cursor-pointer" [routerLink]="['/home']" viewBox="0 0 24 24" fill="none"
        xmlns="http://www.w3.org/2000/svg">
    
        <mask id="mask0_848_1764" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <rect width="24" height="24" fill="#C19725" />
        </mask>
        <g mask="url(#mask0_848_1764)">
            <path d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z" fill="#C19725" />
        </g>
    </svg>
      <img
        class="size-6 sm:size-8 lg:size-10"
        src="/assets/images/user/create-user.png"
        alt="user"
      />
      <span class="font-semibold text-sm sm:text-base lg:text-xl text-444"
        >Kalakar List</span
      >
    </div>
  </div>
  <div
    class="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-2 sm:gap-2.5 lg:gap-3 space-y-0.5"
  >
    <div class="col-span-1 relative" *ngFor="let kalakar of userSupplierList">
      <div *ngIf="kalakar.approval_waiting_count > 0"
        class="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 size-6 bg-c19725 rounded-full flex items-center justify-center text-white text-xs"
      >
        {{ kalakar.approval_waiting_count }}
      </div>
      <div
        class="border border-[#D9D9D9] rounded-[5px] bg-white px-1.5 py-2 flex items-center justify-between gap-2"
        (click)="onKalakaeClick(kalakar?.id)"
      >
        <div class="flex items-center justify-start gap-2">
          <div
            class="size-16 bg-[#F9E698] rounded-[5px] flex justify-center items-center cursor-pointer"
            (click)="openKalakarDetail(kalakar,$event)"
          >
            <img
              class="size-11"
              [src]="kalakar?.documents?.[0]?.doc_user_img || '/assets/images/user/user-profile.png'"
              alt="user profile"
            />
          </div>
          <div
            class="space-y-0.5 text-444 font-normal text-[11px] md:text-[13px]"
          >
            <p class="text-[13px] lg:text-base font-medium">
              {{ kalakar.name }}
            </p>
            <p>
              <span class="me-1">{{ kalakar.mobilenumber }}</span
              >|<span class="ms-1">{{ kalakar.gstnumber }}</span>
            </p>
            <p>{{ kalakar.email }}</p>
          </div>
        </div>
        <div class="flex flex-col space-y-3">
          <button class="cursor-pointer">
            <svg
              class="size-5 lg:size-6"
              viewBox="0 0 24 24"
              fill="none"
              routerLink="/create-user/supplier/{{ kalakar.id }}/edit"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.552 4.332L19.5109 8.29075M3.2815 16.452L2.75 21.25L7.54788 20.7185L21.25 7.00912V5.39287L18.6071 2.75H16.9909L3.2815 16.452Z"
                stroke="#C19725"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14.7166 9.23962L8.10638 15.8499"
                stroke="#C19725"
                stroke-miterlimit="5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <button class="cursor-pointer" (click)="onDelete(kalakar.id)">
            <svg
              class="size-5 lg:size-6"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 12.5V17.5"
                stroke="#BB0000"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14 12.5V17.5"
                stroke="#BB0000"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M4 7.5H20"
                stroke="#BB0000"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 10.5V18.5C6 20.1569 7.34315 21.5 9 21.5H15C16.6569 21.5 18 20.1569 18 18.5V10.5"
                stroke="#BB0000"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9 5.5C9 4.39543 9.89543 3.5 11 3.5H13C14.1046 3.5 15 4.39543 15 5.5V7.5H9V5.5Z"
                stroke="#BB0000"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
